import React, { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectWidthMQ } from 'core/modules/MediaQueries/selectors';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import './Loader.scss';

function Loader({
  isLoading, className = '', isInverted, children,
}) {
  const widthMQ = useSelector(selectWidthMQ);
  const childrenRef = useRef(null);
  const [styles, setStyles] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      const firstChild = childrenRef?.current?.firstChild;

      if (firstChild) {
        const rect = firstChild.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(firstChild);

        setStyles({
          width: rect.width,
          height: rect.height,
          margin: computedStyle.margin,
        });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [children, widthMQ]);

  if (isLoading) {
    return (
      <div className={`mn_loaderWrap ${className}`} style={styles}>
        <div className={`mn_loader ${isInverted ? 'mn_inverted' : ''}`} />
      </div>
    );
  }

  if (className) {
    return <div className={className} ref={childrenRef}>{children}</div>;
  }

  return <div className="mn_loaderContent" ref={childrenRef}>{children}</div>;
}

export default (props) => <ComponentErrorBoundary><Loader {...props} /></ComponentErrorBoundary>;
